import React from 'react';

export function ProjectDocsTemplates() {
  const templates = [
    { id: '1', name: 'Biên bản nghiệm thu', type: 'docx' },
    { id: '2', name: 'Báo cáo tiến độ', type: 'xlsx' },
    { id: '1', name: 'Biên bản nghiệm thu', type: 'docx', size: '2.4 MB' },
    { id: '2', name: 'Báo cáo tiến độ', type: 'xlsx', size: '1.2 MB' },
    { id: '3', name: 'Phiếu yêu cầu vật tư', type: 'pdf', size: '0.8 MB' },
  ];

  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Mẫu tài liệu chuẩn</h3>
        <button className="text-xs font-normal text-emerald-600 hover:underline">Chi tiết</button>
      </div>

      <div className="space-y-2">
        {templates.map((item) => (
          <div key={item.id} className="p-2 rounded-md border border-slate-50 hover:bg-slate-50 transition-colors cursor-pointer group flex items-center gap-3">
             <div className="w-8 h-8 rounded bg-slate-50 flex items-center justify-center shrink-0 group-hover:bg-emerald-50 transition-colors">
                <i className="ri-file-text-line text-slate-400 group-hover:text-emerald-500" />
             </div>
             <div className="min-w-0 flex-1">
                <h4 className="text-xs font-normal text-slate-700 truncate group-hover:text-emerald-600 transition-colors">{item.name}</h4>
                <p className="text-xs font-normal text-slate-400">{item.size}</p>
             </div>
             <i className="ri-download-2-line text-slate-400 group-hover:text-emerald-500 cursor-pointer" />
          </div>
        ))}
      </div>
    </div>
  );
}
